<template>
    <section class="sec-features mt-2">
        <div class="container mt-3 news-container">
            <h2 class="text-20 text-bold mb-4 d-flex align-items-center">
                <i class="iconfpt-promo mr-3"></i>
                <span>Tin tức nổi bật</span>
            </h2>
            <div class="news-content">
                <section-scroll class="feedback-list news-content-block-cate">
                    <div class="feedback-item news-content-block-item">
                        <a href="#">
                             <img class="news-content-block-img" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAKUWNbw1oKyyQf1wVtevN3vedTqsY8vs_pg&usqp=CAU"/>
                        </a>
                        <div class="news-block-child">
                            <a href="#">
                                <h3 class="news-block-child-title">
                                    FPT Telecom ra mắt F-Safe giải pháp bảo mật tích hợp vào modem
                                </h3>
                            </a>
                            <p class="news-block-child-des">
                                F-Safe là sản phẩm bảo mật đầu tiên tại Việt Nam có khả năng bảo vệ toàn bộ....
                                <a class="news-content-a" href="">Đọc tiếp</a>
                            </p>
                        </div>
                    </div>
                    <div class="feedback-item news-content-block-item">
                        <a href="#">
                             <img class="news-content-block-img" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAKUWNbw1oKyyQf1wVtevN3vedTqsY8vs_pg&usqp=CAU"/>
                        </a>
                        <div class="news-block-child">
                            <a href="#">
                                <h3 class="news-block-child-title">
                                    FPT Telecom ra mắt F-Safe giải pháp bảo mật tích hợp vào modem
                                </h3>
                            </a>
                            <p class="news-block-child-des">
                                F-Safe là sản phẩm bảo mật đầu tiên tại Việt Nam có khả năng bảo vệ toàn bộ....
                                <a class="news-content-a" href="">Đọc tiếp</a>
                            </p>
                        </div>
                    </div>
                    <div class="feedback-item news-content-block-item">
                        <a href="#">
                             <img class="news-content-block-img" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAKUWNbw1oKyyQf1wVtevN3vedTqsY8vs_pg&usqp=CAU"/>
                        </a>
                        <div class="news-block-child">
                            <a href="#">
                                <h3 class="news-block-child-title">
                                    FPT Telecom ra mắt F-Safe giải pháp bảo mật tích hợp vào modem
                                </h3>
                            </a>
                            <p class="news-block-child-des">
                                F-Safe là sản phẩm bảo mật đầu tiên tại Việt Nam có khả năng bảo vệ toàn bộ....
                                <a class="news-content-a" href="">Đọc tiếp</a>
                            </p>
                        </div>
                    </div>
                </section-scroll>
            </div>
        </div>
    </section>
</template>

<script>
import * as api from '../../modules/homepage/module/api';
export default {
    components: {},
    name: "News",
    data() {

    },
    methods: {
        load() {

        },
    },
    created() {},
    mounted() {
        this.load();
    },
};
</script>
